
  import { Component } from 'vue-property-decorator'
  import { mapGetters } from 'vuex'
  import { GForm } from '@/components/forms/GForm'
  import GenerateTicket from '@/components/GenerateTicket.vue'

@Component({
  components: {
    GenerateTicket,
  },
  computed: {
    ...mapGetters('app', ['isMini']),
  },
})
  export default class DrawerHeader extends GForm {
  isMini!: boolean;
  path = require('@/assets/Logotipo_Interno.svg');
  pathLogo = require('@/assets/logo.svg');
  }
